import React, { useState } from 'react'
import { Tooltip, styled } from '@tools/wr-catalog-base'
import { LiaCopySolid } from 'react-icons/lia'

export const CopyPartnerLinkButton = ({ partnerUrl }) => {
  const [isTPShown, setIsTPShown] = useState(false)
  const [isFading, setIsFading] = useState(false)

  return (
    <StyledTooltip
      tooltip={'Copied to clipboard'}
      options={{ visible: isTPShown, placement: 'top' }}
      style={{ display: 'inline-block', fontSize: 14 }}
      className={isFading ? 'fading' : ''}
    >
      <a
        onClick={() => {
          navigator.clipboard.writeText(partnerUrl)
          setIsTPShown(true)
          setTimeout(() => {
            setIsTPShown(false)
            setIsFading(false)
          }, 1000)
          setTimeout(() => {
            setIsFading(true)
          }, 100)
        }}
        style={{ marginLeft: 20, color: 'blue' }}
      >
        Share Partner Link <LiaCopySolid />
      </a>
    </StyledTooltip>
  )
}

const StyledTooltip = styled(Tooltip)`
  .tooltip-container {
    transition: opacity 1s;
    opacity: 1;
  }

  &.fading {
    .tooltip-container {
      opacity: 0;
    }
  }
`
